<template>
  <div class="document-container">
    <div class="columns">
      <div class="column" v-if="hasModule('LOCID:LOC:GROUP')">
        <div class="document">
          <div class="header">
            <EsHeader>
              <template #header>
                <div class="header-title">Location Group</div>
              </template>
              <template #actions>
                  <ul>
                    <li class="p-narrow no-border">
                        <div class="list-content">
                          <button class="button is-primary"
                            @click="$router.push({ name: 'addgroup', params: {editing: 'true'} });">
                            Add Group
                          </button>
                        </div>
                    </li>
                  </ul>
              </template>
            </EsHeader>
          </div>
          <div class="content">
            <div class="field is-grouped">
              <p class="control has-icons-right">
                <input id="locationGroupFilter"  type="text"
                class="input"
                v-model="searchName" placeholder="Search by Group Name or Code"
                @focus="showSearchIcon = false"
                @blur="showSearchIcon = true"
                @keyup.enter.prevent="onSubmit">
                <span class="icon is-right">
                  <font-awesome-icon :icon="['fal', 'search']"
                   v-if="searchName === '' && showSearchIcon == true" />
                  <a v-if="searchName !== ''"
                    @click.prevent="onClear">
                    <font-awesome-icon :icon="['fal', 'times']" />
                  </a>
                </span>
              </p>
              <p class="control">
                <popper
                  ref="filter"
                  trigger="click"
                  :options="{
                    placement: 'bottom-end',
                    modifiers: { offset: { offset: '0,10px' } }
                    }">
                  <div class="popper">
                    <div class="filter-container">
                      <form>
                        <div class="field has-text-left">
                          <label for="locationFilter" class="label">Organization</label>
                          <div class="select is-half-width is-block">
                            <select class="input" v-model="organizationCode"
                              @change.prevent="search">
                              <option
                                value=""
                                disabled
                                selected
                                hidden
                                class="invalid">
                                Select Organization
                              </option>
                              <option
                                v-for="organization in organizations"
                                :key="organization.code"
                                :value="organization.code">
                                {{ organization.code }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="field has-text-left">
                          <label for="statusFilter" class="label">Status</label>
                          <div class="field">
                            <input @change.prevent="search"
                              class="is-checkradio"
                              id="statusFilterAll"
                              type="radio"
                              v-model="status"
                              value="all">
                            <label class="radio"
                              for="statusFilterAll">
                              All
                            </label>
                            <input @change.prevent="search"
                              class="is-checkradio"
                              id="statusFilterActive"
                              type="radio"
                              v-model="status"
                              value="true">
                            <label class="radio"
                              for="statusFilterActive">
                              Active
                            </label>
                            <input @change.prevent="search"
                              class="is-checkradio"
                              id="statusFilterInactive"
                              type="radio"
                              v-model="status"
                              value="false">
                            <label class="radio"
                              for="statusFilterInactive">
                              Inactive
                            </label>
                          </div>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="has-text-right">
                          <a class="button is-text" @click.prevent="onClear">Reset</a>
                        </div>
                      </form>
                    </div>
                  </div>
                  <a class="button-filter" slot="reference">
                    <span class="icon is-small">
                      <font-awesome-icon :icon="['fal', 'filter']"/>
                    </span>
                  </a>
                </popper>
              </p>
            </div>
            <es-loader v-if="this.loading === true"/>
            <div v-else>
              <table class="table is-hoverable is-fullwidth">
                <thead>
                  <tr>
                    <th title="Group Name">
                      <a class="sort-by" @click.prevent="changeSort('label')">
                        Group Name
                      </a>
                    </th>
                    <th title="Status of the group">Status</th>
                    <th title="Number of member locations">Locations</th>
                    <th title="Actions">Actions</th>
                  </tr>
                </thead>
                <tbody v-if="groups !== undefined">
                  <tr v-for="group in groups" v-bind:key="group.id"
                  :class="{ 'highlightRow': $route.params.groupId === group.id }">
                    <td class="table-body">
                      <span v-if="group.code">{{ group.code }} - </span>
                      <router-link
                      :to="{
                        name: 'groupProfileDetails',
                        params: { groupId: group.id, group:group },
                        }"
                        >
                        {{ group.label }}
                      </router-link>
                      <div class="tag">
                        {{ group.organizationCode }}
                      </div>
                    </td>
                    <td class="action">
                      <span v-if="group.active === true" title="Active"> Active </span>
                      <span v-else title="Inactive"> Inactive </span>
                    </td>
                    <td class="action">
                      <span :title="group.totalLocations+ ` locations(s)`">
                        {{ group.locationsCount }}
                      </span>
                    </td>
                    <td class="table-action">
                      <div class="icon center-icon mr-2">
                        <router-link
                        :to="{
                          name: 'duplicateGroup',
                          params: { groupId: group.id, duplicateGroup: group }
                          }">
                          <font-awesome-icon :icon="['far', 'clone']"
                             class="fa-lg" title="Duplicate Group"/>
                        </router-link>
                      </div>
                      <div class="icon center-icon">
                        <router-link
                        :to="{
                          name: 'groupLocationList',
                          params: { groupId: group.id, group: group },
                          }">
                          <font-awesome-icon
                            :icon="['far', 'angle-double-right']"
                            class="fa-2x"
                            title="View Location List"
                          />
                        </router-link>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="!isApplyFilter && !groups.length">
                  <tr>
                    <td colspan="7" class="has-text-centered">
                      <div class="no-result-container">
                        <div class="icon">
                          <font-awesome-icon :icon="['fal', 'exclamation-triangle']" size="4x"/>
                        </div>
                        <p></p>
                        <h4>No results were found.</h4>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="isApplyFilter" >
                  <tr>
                    <td colspan="6" class="has-text-centered">
                      <div class="no-result-container">
                        <div class="icon">
                          <font-awesome-icon :icon="['fal','spinner']" class="fa-pulse" size="2x" />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot v-if="groups.length">
                  <tr>
                    <td colspan="100%">
                      <es-pager
                      :totalCount="totalGroups"
                      :pageSize="pageSize"
                      />
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="column" v-if="hasModule('LOCID:MATCH:HISTORY:VIEW') || hasModule('LOCID:MATCH:RESOLVENM:VIEW')">
        <recent-near-match-summary
          v-if="hasModule('LOCID:MATCH:RESOLVENM:VIEW')"
          class="margin-bottom"
          :matches="nearMatches"
          :loading="loaderNearMatch"
        />

        <recent-location-summary
          v-if="hasModule('LOCID:MATCH:HISTORY:VIEW') && hasModule('LOCID:LOC:ADD')"
          :locations="locations"
          :loading="loaderLoacations"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Popper from 'vue-popperjs';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleRight,
  faTimes,
  faCheckCircle,
  faEdit,
  faEllipsisH,
  faFilter,
  faMapMarkerAlt,
  faExclamationTriangle,
  faSpinner,
} from '@fortawesome/pro-light-svg-icons';
import {
  faAngleDoubleRight,
  faClone,
} from '@fortawesome/pro-regular-svg-icons';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsPager from '@/components/EsPager.vue';
import RecentLocationSummary from '@/components/RecentLocationSummary.vue';
import RecentNearMatchSummary from '@/components/RecentNearMatchSummary.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faAngleDoubleRight,
  faAngleRight,
  faClone,
  faTimes,
  faCheckCircle,
  faEdit,
  faEllipsisH,
  faFilter,
  faMapMarkerAlt,
  faExclamationTriangle,
  faSpinner,
);

export default {
  mixins: [BreadcrumbsManager, NotificationManager, PermissionManager],
  components: {
    EsHeader,
    EsLoader,
    EsPager,
    Popper,
    RecentLocationSummary,
    RecentNearMatchSummary,
  },
  data() {
    return {
      loading: false,
      groups: [],
      organizationCode: '',
      organizations: [],
      loaderLoacations: false,
      loaderNearMatch: false,
      locations: [],
      nearMatches: [],
      searchName: '',
      status: 'all',
      showSearchIcon: true,
      isApplyFilter: false,
      sortField: 'label',
      sortOrder: 'ASC',
      pageSize: 25,
      page: 1,
      totalGroups: 0,
    };
  },
  watch: {
    $route: 'getGroups',
    groups() {
      if (!this.groups.length && this.$route.query.page !== 1) {
        this.$router.push({
          query: { ...this.searchParams, page: 1 },
        });
      }
    },
  },
  computed: {
    locationSearchParams() {
      const params = {};
      params.pageSize = 5;

      const sorters = {};
      sorters.field = 'createdDate';
      sorters.order = 'DESC';
      const sort = [];
      sort.push(sorters);
      params.sort = JSON.stringify(sort);
      return params;
    },
    matchSearchParams() {
      const params = {};
      params.pageSize = 5;
      params.open = true;

      const sorters = {};
      sorters.field = 'transDate';
      sorters.order = 'DESC';
      const sort = [];
      sort.push(sorters);
      params.sort = JSON.stringify(sort);
      return params;
    },
    searchParams() {
      const params = {};
      if (this.$route.query.page) {
        params.page = this.$route.query.page;
      }
      if (this.pageSize) {
        params.pageSize = this.pageSize;
      }
      if (this.searchName && this.searchName.trim().length > 0) {
        params.search = this.searchName;
      }

      if (this.status !== 'all') {
        params.status = this.status;
      }
      if (this.organizationCode && this.organizationCode.trim().length > 0) {
        const organizations = [];
        organizations.push(this.organizationCode);
        params.organizations = organizations;
      }
      const sorters = {};
      sorters.field = this.sortField;
      sorters.order = this.sortOrder;
      const sort = [];
      sort.push(sorters);
      if (sorters) params.sort = JSON.stringify(sort);
      return params;
    },
  },
  created() {
    this.setBreadcrumb([
      { text: 'Home', to: {} },
    ]);
    if (this.hasModule('LOCID:LOC:GROUP')) { // if has group list permission
      this.getOrganizations();
      this.getGroups();
    }
    if (this.hasModule('LOCID:APP:NAV:VIEW')) {  // if can see recenlty added locations
      this.getLocations();
    }
    if (this.hasModule('LOCID:MATCH:RESOLVENM:VIEW')) {  // if can see near matches
      this.getNearMatches();
    }
  },
  async mounted() {
    this.urlToParams();
    this.checkNotification();
  },

  methods: {
    async getGroups() {
      this.toggleLoading();
      try {
        const queryParams = new URLSearchParams();
        Object.keys(this.searchParams).forEach((key) => {
          queryParams.append(key, this.searchParams[key]);
        });
        const res = await axios.get('location-groups', { params: queryParams });
        this.groups = res.data.data;
        this.totalGroups = res.data.totalCount;
      } catch (error) {
        const { status } = error.response;
        let apiMsg = '';
        if (status === 500) {
          apiMsg = 'Network Error';
        } else if (status === 400) {
          apiMsg = 'Something went wrong.';
        } else {
          apiMsg = `${error.response.data.message}`;
        }
        this.showNotification('danger', [apiMsg]);
      }
      this.toggleLoading();
    },
    async getLocations() {
      this.toggleLocationLoading();
      try {
        const queryParams = new URLSearchParams();
        Object.keys(this.locationSearchParams).forEach((key) => {
          queryParams.append(key, this.locationSearchParams[key]);
        });
        const res = await axios.get('location-organizations', { params: queryParams });
        this.locations = res.data.data;
      } catch {
        // handle error
      }
      this.toggleLocationLoading();
    },
    async getNearMatches() {
      this.toggleMatchLoading();
      try {
        const queryParams = new URLSearchParams();
        Object.keys(this.matchSearchParams).forEach((key) => {
          queryParams.append(key, this.matchSearchParams[key]);
        });
        const res = await axios.get('search/location/nearmatches', { params: queryParams });
        this.nearMatches = res.data.data;
      } catch {
        // handle error
      }
      this.toggleMatchLoading();
    },
    async search() {
      try {
        this.$router.replace({
          name: 'groupList',
          query: { ...this.searchParams },
        });

        this.isApplyFilter = false;
      } catch (error) {
        console.error(error);
      }
    },
    urlToParams() {
      const {
        page, pageSize, search, status, sort, organizations,
      } = this.$route.query;
      if (page) this.page = page;
      if (pageSize) this.pageSize = pageSize;
      if (search) this.searchName = search;
      if (status) this.status = status;
      if (organizations) this.organizationCode = organizations;
      if (sort) {
        const sortField = JSON.parse(sort)[0];
        this.sortField = sortField.field;
        this.sortOrder = sortField.order;
      }
    },
    onSubmit() {
      this.$refs.filter.showPopper = false;
      this.isApplyFilter = true;
      this.search();
    },
    onClear() {
      this.$refs.filter.showPopper = false;
      this.searchName = '';
      this.organizationCode = '';
      this.status = 'all';
      this.isApplyFilter = true;
      this.search();
    },
    async getOrganizations() {
      try {
        const res = await axios.get('organizations');
        this.organizations = res.data;
      } catch {
        // handle error
      }
    },
    checkNotification() {
      const { message } = this.$route.params;
      if (this.$route.params.message) {
        this.showNotification('success', [message]);
      }
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
    toggleLocationLoading() {
      this.loaderLoacations = !this.loaderLoacations;
    },
    toggleMatchLoading() {
      this.loaderNearMatch = !this.loaderNearMatch;
    },
    changeSort(field) {
      this.sortField = field;
      this.sortOrder = (this.sortOrder === 'ASC' ? 'DESC' : 'ASC');
      this.search();
    },
  },
};
</script>

<style lang="sass" scoped>
  .input
    width: 40%
  .tag
    margin-left: 8px
  .input
    width: 400px
  .filter-container
    padding: 1.5rem
    width: 493px
  .no-result-container
    padding: 6.5rem
  .sort-by
    padding-right: 18px
    position: relative
    color: #777
    text-decoration: none
    &:before, &:after
      border: 4px solid transparent
      content: ""
      display: block
      height: 0
      right: 5px
      top: 50%
      position: absolute
      width: 0
    &:before
      border-bottom-color: #999
      margin-top: -9px
    &:after
      border-top-color: #999
      margin-top: 1px
  .margin-bottom
    margin-bottom: 1rem
  .center-icon
    vertical-align: middle
  .mr-2
    margin-right: .5rem
</style>
